const modal = document.getElementById("modal");
const buttons = document.querySelectorAll(".general-content a:not(.link)");
const span = document.getElementsByClassName("close")[0];
const htmlElement = document.querySelector("html");

// open the modal and disable scrolling of the page
buttons.forEach( function(element){
  element.addEventListener(`click`,function(e){
    e.preventDefault();
    modal.classList.add('visible');
    setTimeout(() => {
      modal.classList.add('show');
    }, 100);

    setTimeout(() => {
      modal.classList.add('visual');
    }, 150);
    htmlElement.classList.add("modal-open");
  });
});

// X btn closes the modal
span.addEventListener('click', function() {
  modal.classList.remove('visual', 'show')
  htmlElement.classList.remove("modal-open");
});

// clicking away will close the modal
window.addEventListener('click', function(e) {
  if (e.target == modal) {
    modal.classList.remove('visual', 'show')
    htmlElement.classList.remove("modal-open");
  }
});
